import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const securityReporter = defineConnector({
  identifier: "securityReporter",
  name: "Security Reporter",
  tagLine: "Penetration test reporting",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://reporter.example.com/api/v1"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
    { name: "Accept", value: { from: "literal", value: "application/json" } },
  ]),
  steps: [
    {
      title: "Set up Security Reporter",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API token for your Reporter user with read access to clients, or ask your Reporter administrator for one. Enter your instance API URL and the token below. The connection test reads at most one client. See the [official API client guide](https://python-reporter.readthedocs.io/en/latest/getting-started.html).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://reporter.example.com/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Enter your Reporter instance’s HTTPS URL followed by /api/v1, for example https://reporter.example.com/api/v1.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Use an API token with read access to clients. The token’s permissions determine which resources the connector can read.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://reporter.example.com/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/clients?page%5Bsize%5D=1",
      method: "GET",
    }),
  },
});
